import React from 'react';

import Header from '../../layout/Header.jsx';
import ListAssignments from '../../lists/ListAssignments.jsx';

const PageAssignments = () => (
  <div>
    <Header>Assignments</Header>
    <ListAssignments />
  </div>
);

export default PageAssignments;
